import { memo } from 'react';

function TailLoad(props) {
  const { color = '#666666', size = 14 } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M-5.82676e-08 1.33301C0.000177484 0.59993 0.599931 0.000176827 1.33301 -4.66269e-07L1.33301 1.33301L-5.82676e-08 1.33301ZM-1.74846e-07 4L-1.16578e-07 2.66699L1.33301 2.66699L1.33301 4L-1.74846e-07 4ZM-2.91423e-07 6.66699L-2.33113e-07 5.33301L1.33301 5.33301L1.33301 6.66699L-2.91423e-07 6.66699ZM-4.07959e-07 9.33301L-3.49691e-07 8L1.33301 8L1.33301 9.33301L-4.07959e-07 9.33301ZM1.33301 12L-5.24537e-07 12L-4.66269e-07 10.667L1.33301 10.667L1.33301 12ZM1.33301 14.667C0.599822 14.6668 -6.14855e-07 14.0662 -5.82804e-07 13.333L1.33301 13.333L1.33301 14.667ZM2.66699 1.33301L2.66699 -4.07959e-07L4 -3.49691e-07L4 1.33301L2.66699 1.33301ZM2.66699 14.667L2.66699 13.333L4 13.333L4 14.667L2.66699 14.667ZM5.33301 1.33301L5.33301 -2.91423e-07L6.66699 -2.33113e-07L6.66699 1.33301L5.33301 1.33301ZM5.33301 14.667L5.33301 13.333L6.66699 13.333L6.66699 14.667L5.33301 14.667ZM8 1.33301L8 -1.74846e-07L9.33301 -1.16578e-07L9.33301 1.33301L8 1.33301ZM12 13.333C12 14.0662 11.4002 14.6668 10.667 14.667L8 14.667L8 8L12 8L12 13.333ZM10.667 1.33301L10.667 -5.82676e-08C11.4001 0.000177494 11.9998 0.599931 12 1.33301L10.667 1.33301ZM10.667 4L10.667 2.66699L12 2.66699L12 4L10.667 4ZM10.667 6.66699L10.667 5.33301L12 5.33301L12 6.66699L10.667 6.66699Z"
        fill={color}
      />
    </svg>
  );
}
export default memo(TailLoad);
